<script setup lang="ts">
/** A hairline between groups of menu entries. */
</script>

<template>
  <div class="nx-context-menu-separator" role="separator" />
</template>

<style scoped>
.nx-context-menu-separator {
  flex: none;
  height: var(--nxt-hairline);
  margin: var(--nxt-space-2xs) var(--nxt-space-xs);
  background: var(--nxt-border);
}
</style>
